import React from "react"
import { Link } from "gatsby"

import FacioLogoAlternative from "assets/logos/facio-alternative.svg"

import styles from "./footer.module.css"

import PlayStore from "assets/google-play-badge.svg"
import AppStore from "assets/app-store-badge.svg"

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className="wrapper">
        <div className={styles.grid}>
          <FacioLogoAlternative className={styles.logo} />

          <div className={styles.help}>
            <small>
              Facio.com.br pertence à Facio Pagamentos Ltda. (“Facio”), CNPJ
              31.703.183/0001-35, com sede na Rua Claudio Soares, 72, Pinheiros,
              São Paulo, SP, CEP: 05422-030
            </small>
            <h4>Aplicativo Facio</h4>
            <p className={styles.downloadButtons}>
              <a href="https://play.google.com/store/apps/details?id=com.facio.facio_app">
                <PlayStore alt="Download na play store" />
              </a>
              <a href="https://apps.apple.com/br/app/facio/id1487549868">
                <AppStore alt="Download na app store" />
              </a>
            </p>
            <div className={styles.helpBlock}>
              <p>
                <strong> Precisa de ajuda?</strong>
              </p>
              <p>Chama a gente no Whatsapp</p>
              <p>
                <a href="https://web.whatsapp.com/send?phone=551140405509 ">
                  (11) 4040-5509
                </a>
              </p>
            </div>
          </div>

          <div className={styles.links}>
            <div className={styles.column}>
              <h4>Explore</h4>
              <ul className={styles.footerList}>
                <li>
                  <Link to="/">Início</Link>
                </li>
                <li>
                  <Link to="/empresas">Empresas</Link>
                </li>
                <li>
                  <Link to="/funcionarios">Funcionários</Link>
                </li>
                <li>
                  <Link to="/sobre-a-facio">Sobre a Facio</Link>
                </li>
                <li>
                  <Link to="/imprensa">Imprensa</Link>
                </li>
              </ul>
            </div>
            <div className={styles.column}>
              <h4>Produtos</h4>
              <ul className={styles.footerList}>
                <li>
                  <Link to="/produtos/educacao-financeira">
                    Educação financeira
                  </Link>
                </li>
                <li>
                  <Link to="/produtos/poupe-facio">Poupe Facio</Link>
                </li>
                <li>
                  <Link to="/produtos/antecipacao-de-salario">
                    Antecipação de salário
                  </Link>
                </li>
                <li>
                  <Link to="/produtos/credito-consignado">
                    Crédito consignado
                  </Link>
                </li>
              </ul>
            </div>
            <div className={styles.column}>
              <h4>Transparência</h4>
              <ul className={styles.footerList}>
                <li>
                  <Link to="/contratos/antecipacao">
                    Contrato de antecipação
                  </Link>
                </li>
                <li>
                  <Link to="/contratos/credito-consignado">
                    Contrato de crédito consignado
                  </Link>
                </li>
                <li>
                  <Link to="/contratos/conta-digital">
                    Contrato de conta digital
                  </Link>
                </li>
                <li>
                  <Link to="/contratos/politica-de-privacidade">
                    Política de privacidade
                  </Link>
                </li>
              </ul>
            </div>
            <div className={styles.column}>
              <h4>E-books</h4>
              <ul className={styles.footerList}>
                <li>
                  <Link to="/e-book/">O bem-estar financeiro</Link>
                </li>
                <li>
                  <Link to="/e-book/">Benefícios modernos</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className={styles.legal}>
            <p>
              {" "}
              <small>
                A Facio é uma plataforma digital que atua como correspondente
                Bancário para facilitar o processo de contratação de
                empréstimos. Como Correspondente Bancário, seguimos as
                diretrizes da Resolução nº 3.954 de 24 de fevereiro de 2011 do
                Banco Central do Brasil. Somos correspondentes bancários da
                seguinte instituição: BMP Money Plus Sociedade de Crédito Direto
                S.A. inscrita no CNPJ 34.337.707/0001-00.
              </small>
            </p>
            <p>
              <small>
                Informações adicionais relativas ao Empréstimo consignado em
                folha de pagamento: mínimo 2 meses e máximo 60 meses. Exemplo de
                Empréstimo consignado em folha de pagamento - Empréstimo de R$
                5.000,00 para pagar em 5 meses – 5 prestações de R$ 1.000,00 e 1
                prestação de R$ 576,77, com uma taxa de juros de 1,9% ao mês +
                IOF. CET de 32,75% ao ano.
              </small>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
